import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import firebase from "firebase/app";
import "./ContentSearch.css";

function ContentSearch(props) {
  const [token, setToken] = useState("");
  const [status, setStatus] = useState("ready");

  const [path, setPath] = useState("");
  const [searchString, setSearchString] = useState("");

  const [csv, setCSV] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    firebase
      .auth()
      .currentUser.getIdToken()
      .then(id_token => {
        setToken(id_token);
      });
  }, [token]);

  const onChange = (event, updateFunction) => {
    event.preventDefault();
    updateFunction(event.target.value);
  };

  const submit = event => {
    event.preventDefault();
    setStatus("running");

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Content-Type", "application/json");

    fetch(
      "https://us-central1-broadlume-fit.cloudfunctions.net/contentSearch",
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          path,
          searchString
        })
      }
    )
      .then(response => {
        response.text().then(function(text) {
          setCSV(text);
          setStatus("finished");
        });
      })
      .catch(error => {
        setError(error.message);
        setStatus("error");
        console.log(error);
      });
  };

  const clear = _event => {
    setPath("");
    setSearchString("");
    setStatus("ready");
  };

  return (
    <div className="content-search">
      <div className="forms__label">Global Website Search</div>
      <div>
        <input
          type="text"
          name="searchString"
          placeholder="Search Content"
          className="content-search__input content-search__search-string"
          value={searchString}
          onChange={event => onChange(event, setSearchString)}
        />
      </div>
      <div>
        <input
          type="text"
          name="path"
          placeholder='Path (default "/")'
          className="content-search__input content-search__path"
          value={path}
          onChange={event => onChange(event, setPath)}
        />
      </div>
      {status === "ready" && (
        <div>
          <input
            className="app__primary-button content-search__button"
            type="submit"
            value="Search"
            onClick={submit}
          />
          <input
            className="app__primary-button"
            type="button"
            onClick={clear}
            value="Clear"
          />
        </div>
      )}
      {status === "running" && (
        <div>
          Search in progress, please do not reload or navigate away from this
          page. Searches can take up to 3 minutes.
        </div>
      )}
      {status === "finished" && (
        <div>
          Search completed!{" "}
          <CSVLink
            data={csv}
            target="_blank"
            filename={`content-search-${searchString}.csv`}
            onClick={clear}
          >
            Download now
          </CSVLink>
        </div>
      )}
      {status === "error" && (
        <div>
          Content Search has encountered an error: {error}.
          <br />
          <input
            className="app__primary-button"
            type="button"
            onClick={clear}
            value="Clear"
          />
        </div>
      )}
    </div>
  );
}

export default ContentSearch;
